import axios from '@/libs/api.request';

export const getImportTaskList = (data) => {
  return axios.request({
    url: '/admin/ImportOperation/GetImportTaskList',
    method: 'post',
    data,
  });
};

export const getImportTaskErrors = (data) => {
  return axios.request({
    url: '/admin/ImportOperation/GetImportTaskErrors',
    method: 'post',
    data,
  });
};

